// Combines data into top 4 types plus "Other" based on counts
export const combineDonutChartData = (data) => {
    if (data.length < 6) {
        return data;
    }
    // Get all values except "other"
    const dataWithoutOther = data.filter(({ label }) => label.toLowerCase() !== 'other');
    // If "other" exists in data, determine its value
    const totalOther = data.find(({ label }) => label.toLowerCase() === 'other')?.value || 0;
    // Sort non-"other" data by value descending
    const dataSorted = dataWithoutOther.sort((a, b) => b.value - a.value);
    // Determine top 4 values to show
    const top4 = dataSorted.slice(0, 4);
    // Sum up all other values not in the top 4
    const totalRemaining = dataSorted.slice(4).reduce((sum, { value }) => sum + value, 0);
    return [
        ...top4,
        {
            label: 'Other',
            value: totalRemaining + totalOther, // Make sure "other" exists in the data if it is included
        },
    ];
};
export const sortDonutChartData = (a, b) => {
    if (a.label === 'Other') {
        return 1;
    }
    if (b.label === 'Other') {
        return -1;
    }
    return a.value < b.value ? 1 : -1;
};
